'use client';

import { BasketProvider, type CoreBasketModel } from '~/context/basket-context';
import {
  CurrencyProvider,
  type CurrencyTaxStatus,
} from '~/context/currency-context';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TRPCProvider } from '~/trpc/client';
import OneTrustProvider from '~/context/onetrust-context';
import { FavouritesProvider } from '~/context/favourites-context';

interface ProvidersProps {
  children: React.ReactNode;
  initialBasket: CoreBasketModel | null;
  initialCurrencyTaxStatus?: CurrencyTaxStatus;
  isAuthenticated?: boolean;
}

/**
 * ### Providers
 * Use this component to wrap the application with the necessary **context providers**.
 */
export function Providers({
  children,
  initialBasket,
  initialCurrencyTaxStatus,
  isAuthenticated = false,
}: ProvidersProps) {
  return (
    <OneTrustProvider>
      <TRPCProvider>
        <CurrencyProvider initialCurrencyTaxStatus={initialCurrencyTaxStatus}>
          <FavouritesProvider isAuthed={isAuthenticated}>
            <BasketProvider initialBasket={initialBasket}>
              {children}
              <ReactQueryDevtools initialIsOpen={false} />
            </BasketProvider>
          </FavouritesProvider>
        </CurrencyProvider>
      </TRPCProvider>
    </OneTrustProvider>
  );
}
